export const PromotionCampaignStatusEnum = Object.freeze({
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  PAUSED: "PAUSED",
  DEPLETED: "DEPLETED",
  EXPIRED: "EXPIRED",
});
